import React from 'react';
import { Box, Container, Heading, Text, SimpleGrid, VStack, HStack, Avatar, Badge } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';

const MotionBox = motion(Box);

const ExperiencedSuccess = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            <Text fontSize="lg" color="brand.500" maxW="2xl">
              {data.description}
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} w="full">
            {data.stories.map((story, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <Box
                  p={8}
                  bg="brand.50"
                  borderRadius="2xl"
                  h="full"
                  _hover={{
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(16,185,129,0.2)',
                    bg: 'white',
                  }}
                  transition="all 0.3s"
                >
                  <VStack spacing={4} align="start">
                    <Avatar src={story.image} size="xl" />
                    
                    <VStack align="start" spacing={2}>
                      <Heading size="md" color="brand.800">
                        {story.name}
                      </Heading>
                      
                      <HStack spacing={2} align="center">
                        <Text fontSize="sm" color="brand.500">
                          {story.before}
                        </Text>
                        <FaArrowRight size={12} color="#10B981" />
                        <Text fontSize="sm" color="accent.green" fontWeight="700">
                          {story.after}
                        </Text>
                      </HStack>
                      
                      <Text fontSize="sm" color="brand.600">
                        @ {story.company}
                      </Text>
                      
                      <Badge
                        px={3}
                        py={1}
                        bg="accent.green"
                        color="white"
                        fontSize="sm"
                        fontWeight="700"
                        borderRadius="full"
                      >
                        {story.increase}
                      </Badge>
                    </VStack>
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default ExperiencedSuccess;